import API from "@/package/config/main-api";
import {
  IScoreCreateResponse,
  IScoreListResponse,
} from "../types/backend-types";

export const apiGetUserScores = () => {
  return API.get<IScoreListResponse>("api/v2/user/accounts");
};

export const apiSetMainScore = (scoreId: string) => {
  return API.post(`api/v2/user/accounts/${scoreId}/main`);
};

export const apiCreateUserScore = (scoreId: string) => {
  return API.post<IScoreCreateResponse>("api/v2/user/accounts", {
    account_id: scoreId,
  });
};
